import { render, staticRenderFns } from "./CheckoutDashboard.vue?vue&type=template&id=5d258ea1&scoped=true"
import script from "./CheckoutDashboard.vue?vue&type=script&lang=js"
export * from "./CheckoutDashboard.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDashboard.vue?vue&type=style&index=0&id=5d258ea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d258ea1",
  null
  
)

export default component.exports